import { render, staticRenderFns } from "./CardQuestionDetails.vue?vue&type=template&id=ffc03fe2"
import script from "./CardQuestionDetails.vue?vue&type=script&lang=js"
export * from "./CardQuestionDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports